import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type DeactivateUserModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  name: string | null;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DeactivateUserModal(props: DeactivateUserModalProps) {
  const { isOpen, isLoading, name, onConfirm, onCancel } = props;
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={props.onCancel}>
          {t("Deactivate {{ name }}?", { name })}
        </DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            <Trans>
              By clicking ‘Deactivate user’, {{ name }}’s account access will be
              revoked.
            </Trans>
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton size="medium" onPress={onCancel} testID="cancel-button">
            <Trans>Cancel</Trans>
          </BasicButton>
          <DangerButton
            type="submit"
            size="medium"
            isLoading={isLoading}
            onPress={() => onConfirm()}
            testID="deactivate-confirm-button"
          >
            <Trans>Deactivate user</Trans>
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
